import { DV_360_PLATFORM, GOOGLE_PLATFORM, TIKTOK_PLATFORM } from '../../../constants/selectLists/platformList'
import { AD_DV360_EDIT, AD_GOOGLE_EDIT, AD_TIK_TOK_EDIT } from '../../../constants/forms'

// enhance with other platforms in the future
export const getAdEditFormName = platform => {
  if (platform === GOOGLE_PLATFORM) {
    return AD_GOOGLE_EDIT
  }
  if (platform === DV_360_PLATFORM) {
    return AD_DV360_EDIT
  }
  if (platform === TIKTOK_PLATFORM) {
    return AD_TIK_TOK_EDIT
  }
}
